// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__aJy+X","footerContent":"Footer_footerContent__eoXWi","socials":"Footer_socials__UKCZy","footerBottom":"Footer_footerBottom__wbc+v"};